module.exports = __webpack_public_path__ + "static/media/moon-stars.7b80ba63.svg";